import type { Observable } from 'rxjs';

import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BreakpointsService {
  readonly #breakpointObserver = inject(BreakpointObserver);
  readonly isMobile$: Observable<boolean>;
  readonly isWeb$: Observable<boolean>;
  readonly isTablet$: Observable<boolean>;

  constructor() {
    this.isMobile$ = this.#breakpointObserver.observe([Breakpoints.Handset]).pipe(
      map((result) => result.matches),
      distinctUntilChanged(),
      shareReplay()
    );

    this.isWeb$ = this.#breakpointObserver.observe([Breakpoints.Web]).pipe(
      map((result) => result.matches),
      distinctUntilChanged(),
      shareReplay()
    );

    this.isTablet$ = this.#breakpointObserver.observe([Breakpoints.Tablet]).pipe(
      map((result) => result.matches),
      distinctUntilChanged(),
      shareReplay()
    );
  }
}
